<template>
  <div class="product-builder">
    <div class="container">
      <h2 class="product-builder__heading headingTwo">Build Your Own</h2>
      <ul
        v-for="option in product.options" v-show="option.name === currentOption" :key="option.name"
        class="product-builder__main"
      >
        <!-- main -->
        <li class="product-builder__subheading product-builder__optionsHeading paragraph">
          {{ option.summaryTitle
          }}
        </li>
        <li
          v-for="optionProduct in option.products" :key="optionProduct.id" class="product-builder__option"
          :class="{ 'product-builder__option--selected': isOptionSelected(optionProduct.id, option.name) }"
          @click.prevent="setOption(option.name, optionProduct)"
        >
          <div class="product-builder__image">
            <img :src="optionProduct.icon" :alt="optionProduct.name">
          </div>
          <h4>{{ optionProduct.name }}</h4>
        </li>
        <li v-if="option.help !== ''" class="product-builder__help">
          <h3 class="product-builder__subheading paragraph">Help Text</h3>
          <p class="paragraph">{{ option.help }}</p>
        </li>
      </ul>

      <ul class="product-builder__sidebar">
        <!-- sidebar -->
        <li class="product-builder__subheading product-builder__selectionsHeading paragraph">Unit Summary</li>

        <li class="product-builder__selection product-builder__selection--selected">
          <h4 class="paragraphSmall">Item</h4>
          <p class="paragraphSmall">{{ product.name }}</p>
        </li>
        <li
          v-for="option in product.options" :key="option.name" class="product-builder__selection"
          :class="{ 'product-builder__selection--selected': (productName(option.name) != '') }"
          @click.prevent="setCurrentOption(option.name)"
        >
          <h4 class="paragraphSmall">{{ option.summaryTitle }}</h4>
          <p v-if="productName(option.name) == ''" class="paragraphSmall">{{ option.summaryDefault }}</p>
          <p v-else class="paragraphSmall" v-html="productName(option.name)" />
        </li>
        <li class="product-builder__price">
          <h3 class="headingFive">{{ total }}</h3>
          <a
            class="button button--builder" href="#!" :class="{ 'button--disabled': !selectionsCompleted }"
            @click.prevent="saveProduct"
          >Add To Project Book</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { eventBus } from '../app';

export default {
	props: {
		product: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			optionOrder: [],
			selectedOptions: null,
			currentOption: null,
			itemType: 'builder'
		};
	},
	computed: {
		total() {
			return this.getTotal().toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
		},
		selectionsCompleted() {
			return this.isProjectItemReadyToSave();
		}
	},
	created() {
		for (let item of this.product.options) {
			this.optionOrder.push(item.name);
		}
		this.currentOption = this.optionOrder[0];
		this.selectedOptions = this.product.selectedOptions;
	},
	methods: {
		productName(handle) {
			if (!Object.hasOwn(this.selectedOptions, handle) || this.selectedOptions[handle] === null) {
				return '';
			}

			if (this.selectedOptions[handle].constructor === Array) {
				if (this.selectedOptions[handle].length < 1) {
					return '';
				}

				return this.selectedOptions[handle].map(option => option.name).join('<br/>');
			}

			if (Object.hasOwn(this.selectedOptions[handle], 'required') && this.selectedOptions[handle].required > 1) {
				return this.selectedOptions[handle].required + ' x ' + this.selectedOptions[handle].name;
			}

			return this.selectedOptions[handle].name;
		},
		setOption(handle, product) {
			switch (handle) {
				case 'basin':
					this.selectedOptions[handle] = product;
					this.setNextOption(this.showWorktops(product) ? handle : 'worktop');
					break;

				case 'accessories':
					if (this.isOptionSelected(product.id, handle)) {
						this.removeOption(product.id, handle);
					} else {
						this.selectedOptions[handle].push(product);
					}
					break;

				default:
					this.selectedOptions[handle] = product;
					this.setNextOption(handle);
			}
		},
		removeOption(productId, handle) {
			if (this.selectedOptions === null || this.selectedOptions[handle] === null) {
				return;
			}

			if (this.selectedOptions[handle].constructor === Array) {
				let removeIndex = this.selectedOptions[handle].map(product => product.id).indexOf(productId);

				if (removeIndex >= 0) {
					this.selectedOptions[handle].splice(removeIndex, 1);
				}
			}
		},
		showWorktops(product) {
			const worktopOptions = this.product.options.find(option => {
				return option.name === 'worktop';
			});

			if (typeof worktopOptions === 'undefined') {
				return false;
			}

			if (product.requiresWorktop && worktopOptions.products.length > 1) {
				return true;
			}

			if (product.requiresWorktop && worktopOptions.products.length === 1) {
				this.selectedOptions['worktop'] = worktopOptions.products[0];
				return false;
			}

			this.selectedOptions['worktop'] = { 'id': null, 'name': 'N/A', 'price': 0.00 };
			return false;
		},
		setNextOption(handle) {
			const nextOptionIndex = this.optionOrder.indexOf(handle) + 1;

			if (nextOptionIndex === this.optionOrder.length) {
				return;
			}

			this.currentOption = this.optionOrder[nextOptionIndex];
		},
		setCurrentOption(handle) {
			if (this.selectedOptions === null || this.selectedOptions[handle] === null) {
				return;
			}

			this.currentOption = handle;
		},
		isOptionSelected(productId, handle) {
			if (!Object.hasOwn(this.selectedOptions, handle) || this.selectedOptions[handle] === null) {
				return false;
			}

			if (this.selectedOptions[handle].constructor === Array) {
				let optionFound = this.selectedOptions[handle].find(option => {
					return option.id === productId;
				});

				return optionFound;
			}

			return productId === this.selectedOptions[handle].id;
		},
		getTotal() {
			const self = this;
			let total = 0;

			Object.keys(self.selectedOptions).forEach(option => {
				if (self.selectedOptions !== null && self.selectedOptions[option] !== null && Object.hasOwn(self.selectedOptions[option], 'price') && Object.hasOwn(self.selectedOptions[option], 'required')) {
					total += (self.selectedOptions[option].price * self.selectedOptions[option].required);
				} else if (self.selectedOptions !== null && self.selectedOptions[option] !== null && Object.hasOwn(self.selectedOptions[option], 'price')) {
					total += self.selectedOptions[option].price;
				} else if (self.selectedOptions !== null && self.selectedOptions[option] && self.selectedOptions[option].constructor === Array) {
					for (let i = 0; i < self.selectedOptions[option].length; i++) {
						if (Object.hasOwn(self.selectedOptions[option][i], 'price')) {
							total += self.selectedOptions[option][i].price;
						}
					}
				}
			});

			return total;
		},
		isProjectItemReadyToSave() {
			const self = this;

			if (self.selectedOptions === null) {
				return false;
			}

			let itemReady = true;

			Object.keys(self.selectedOptions).forEach(option => {
				if (self.selectedOptions[option] === null) {
					itemReady = false;
				}
			});

			return itemReady;
		},
		saveProduct() {
			if (!this.isProjectItemReadyToSave()) {
				return;
			}

			eventBus.$emit('save-product', { type: this.itemType, item: this.selectedOptions });
		}
	}
};
</script>